import React from 'react';

const DocViewer = ({ src }) => (
	// eslint-disable-next-line jsx-a11y/iframe-has-title
	<iframe
		style={{ width: '130%', height: '100%', margin: '40px -70px 0px' }}
		src={src}
		frameBorder="0"
	/>
);

export default DocViewer;
